import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {NgForm} from '@angular/forms';
import {filtersToQuerySkipProperties} from '@shared/constants/filters-to-query.constants';
import {
  GenericFunctionsUtil,
  responsiveBreakpoints,
  ResponsiveService
} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {Subscription} from 'rxjs';

@Component({
  selector: 'si-generic-filters',
  templateUrl: './generic-filters.component.html',
  styleUrls: ['./generic-filters.component.scss']
})
export class GenericFiltersComponent implements OnDestroy {
  @Input() name = 'genericFilters';
  @Input() form: NgForm;
  @Input() filters: any;
  @Input() defaultFilters: any;
  @Input() excludedFilters = [];
  @Input() cardClass = 'card';
  @Input() showMoreButtonIcon = 'icon-enlarge';
  @Input() showMoreButtonClass = 'si-button_show-more';
  @Input() showFewerButtonClass = 'si-button_show-fewer';
  @Input() clearButtonClass = 'si-button_secondary';
  @Input() filterButtonClass = 'si-button_main';
  @Output() submitChange = new EventEmitter<any>();
  @Output() filtersChange = new EventEmitter<any>();
  subscriptions: Subscription[] = [];
  isDesktopWidth: boolean;
  filtersStorageManualSet = 0;
  activeFiltersCount = 0;
  private _manualSubmit = 0;

  constructor(
    private responsiveService: ResponsiveService
  ) {
    this.setResponsiveLogic();
  }

  get manualSubmit(): number {
    return this._manualSubmit;
  }

  @Input()
  set manualSubmit(val) {
    this._manualSubmit = val;
    if (val) {
      this.onSubmit();
    }
  }

  setResponsiveLogic(): void {
    this.subscriptions.push(
      this.responsiveService.getResponsiveStoreObservable().subscribe(responsiveStore => {
        this.isDesktopWidth = responsiveStore.currentWindowWidth >= responsiveBreakpoints.MD;
      })
    );
  }

  onSubmit(): void {
    if (this.form?.invalid) {
      return;
    }

    this.filtersStorageManualSet += 1;
    this.getActiveFiltersCount(this.filters);
    this.submitChange.emit();
  }

  onClickClearFilters(): void {
    this.clearFilters();
    this.onSubmit();
  }

  clearFilters(): void {
    Object.keys(this.filters).forEach(key => this.filters[key] = null);
    Object.assign(this.filters, this.defaultFilters);
  }

  closeFilters(): void {
    this.filters.showFilters = false;
    this.filtersStorageManualSet += 1;
  }

  showMoreFilters(): void {
    this.filters.showFilters = true;
    this.filtersStorageManualSet += 1;
  }

  onSiStorageModelChange(newFilters: any): void {
    this.updateAndSubmitFilters(newFilters);
  }

  onSiStorageNoItemChange(): void {
    this.updateAndSubmitFilters(this.defaultFilters);
  }

  updateAndSubmitFilters(newFilters: any): void {
    const newFiltersCopy = GenericFunctionsUtil.deepClone(newFilters);
    Object.keys(this.filters).forEach(key => delete this.filters[key]);
    Object.assign(this.filters, newFiltersCopy);
    this.filtersChange.emit(this.filters);
    this.onSubmit();
  }

  getActiveFiltersCount(filters: any): void {
    // delete excludedFilters and filtersToQuerySkipProperties in active filters count
    const filteredObj = GenericFunctionsUtil.deepClone(filters);
    const excludedKeys = [...this.excludedFilters, ...filtersToQuerySkipProperties];
    excludedKeys.forEach(key => delete filteredObj[key]);
    this.activeFiltersCount = GenericFunctionsUtil.getActiveFiltersCount(filteredObj);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
